<template>
  <!--在线客服-->
  <div class="shoucangbox" v-loading="loading">
    <headerbox :focus="5"></headerbox>
    <div class="fixedcolor"></div>
    <div class="shoucang-top">
      <div class="left">
        <img
          @click="jumppre()"
          src="../../public/statics/img/shop/logos.png"
          alt=""
        />
      </div>
    </div>
    <div class="shoucang-content">
      <div class="dec-top">
        <div
          :class="comeType == 1 ? 'active  cursor' : ' active1 cursor'"
          @click="changeType(1)"
        >
          购物车&nbsp;({{ this.cartotal }})
        </div>
        <div
          :class="comeType == 2 ? 'active  cursor' : ' active1 cursor'"
          @click="changeType(2)"
        >
          收藏商品&nbsp;({{ this.cangtotal }})
        </div>
      </div>
      <div class="dec-content" v-show="comeType == 1">
        <el-table
          :data="dataList"
          ref="detailTable"
          style="
            width: 100%;
            border-radius: 5px 5px 0px 0px;
            border: 1px solid #eeeeee;
            margin: 20px 0 20px 0;
          "
          :row-class-name="tableRowClassName"
          @row-click="onRowClick"
          :header-cell-style="{
            background: '#F7F7F7',
            fontSize: '14px',
            color: '#333333',
          }"
        >
          <el-table-column type="selection" width="55">
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.checked"
                @change.native="cout()"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            label="产品信息"
            prop="goodsNum"
            min-width="260"
            align="center"
            style="background-color: rgba(57, 126, 169, 1); width: 7rem"
          >
            <template slot-scope="scope">
              <div class="d1" @click="todetail(scope.row.goods_id)">
                <div class="d2">
                  <img
                    :src="scope.row.image"
                    alt=""
                    style="width: 100%; object-fit: contain"
                  />
                </div>
                <div class="d3">
                  <span>{{ scope.row.goods_name }}</span>
                  <span>规格：{{ scope.row.suk }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="单位"
            prop="goodsNum"
            align="center"
            style="background-color: rgba(57, 126, 169, 1); width: 2rem"
          >
            <template slot-scope="scope">
              <div class="d1">
                <span v-if="scope.row.goods_spec != ''">{{
                  scope.row.goods_spec
                }}</span>
                <span v-else>--</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="产品规格"
            prop="goodsNum"
            min-width="130"
            style="background-color: rgba(57, 126, 169, 1); width: 1.5rem"
            align="center"
          >
            <template slot-scope="scope">
              <div class="d4">
                <span>规格：{{ scope.row.width }}*{{ scope.row.height }}</span>
                <span>颜色：{{ scope.row.color }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="单价（元）"
            prop="goodsNum"
            style="background-color: rgba(57, 126, 169, 1); width: 1.5rem"
            align="center"
          >
            <template slot-scope="scope">
              <div class="d1">
                <span class="d5">￥{{ scope.row.price }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="数量"
            prop="goodsNum"
            min-width="150"
            style="background-color: rgba(57, 126, 169, 1); width: 1.5rem"
            align="center"
          >
            <template slot-scope="scope">
              <div class="d1">
                <el-input-number
                  v-model="scope.row.cart_num"
                  @change="handleChange(scope.row.id, scope.row.cart_num)"
                  :min="1"
                  label="描述文字"
                ></el-input-number>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="小计（元）"
            prop="goodsNum"
            style="background-color: rgba(57, 126, 169, 1); width: 1.5rem"
            align="center"
          >
            <template slot-scope="scope">
              <div class="d1">
                <span class="d5">￥{{ scope.row.subtotal }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            style="background-color: rgba(57, 126, 169, 1); width: 1.5rem"
          >
            <template slot-scope="scope">
              <div class="d4">
                <span
                  class="d6 cursor"
                  @click="deleteC(scope.row.id, scope.row.product_attr_unique)"
                  >删除</span
                >
                <span class="d10 cursor" @click="addCang(scope.row.goods_id)"
                  >添加收藏</span
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="dec-content" v-show="comeType == 2">
        <el-table
          :data="dataList1"
          style="
            width: 100%;
            border-radius: 5px 5px 0px 0px;
            border: 1px solid #eeeeee;
            margin: 20px 0 20px 0;
          "
          :header-cell-style="{
            background: '#F7F7F7',
            fontSize: '14px',
            color: '#333333',
          }"
        >
          <el-table-column
            label="产品图片"
            prop="goodsNum"
            min-width="200"
            align="center"
            style="background-color: rgba(57, 126, 169, 1); width: 8rem"
          >
            <template slot-scope="scope">
              <div class="d1">
                <div class="d2">
                  <img
                    :src="scope.row.image"
                    alt=""
                    style="width: 1rem; object-fit: contain"
                  />
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="产品信息"
            prop="goodsNum"
            min-width="300"
            align="center"
            style="background-color: rgba(57, 126, 169, 1); width: 8rem"
          >
            <template slot-scope="scope">
              <div class="d1" @click="todetail(scope.row.goods_id)">
                <div class="d3">
                  <span>{{ scope.row.goods_name }}</span>
                  <!-- <span>订货编号：{{ scope.row.pNum }}</span> -->
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label="产品规格"
            prop="goodsNum"
            min-width="300"
            style="background-color: rgba(57, 126, 169, 1); width: 1.5rem"
            align="center"
          >
            <template slot-scope="scope">
              <div class="d7">
                <span>规格：{{ scope.row.width }}*{{ scope.row.height }}</span>
                <span>颜色：{{ scope.row.color }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="价格（元）"
            prop="goodsNum"
            min-width="200"
            style="background-color: rgba(57, 126, 169, 1); width: 1.5rem"
            align="center"
          >
            <template slot-scope="scope">
              <div class="d1">
                <span class="d5">￥{{ scope.row.price }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="操作" min-width="200" align="center">
            <template slot-scope="scope">
              <div class="d9">
                <span class="d8 cursor" @click="addCar(scope.row.goods_id)"
                  >加入购物车</span
                >
                <span class="d10 cursor" @click="qCang(scope.row.goods_id)"
                  >取消收藏</span
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="content-bottom" v-show="comeType == 1">
        <div class="bottom-left">
          <el-checkbox v-model="checkall" @change.native="handleCheckAllChange">
          </el-checkbox>
          <span style="margin-left: 0.2rem">全选</span>
          <span style="margin-left: 0.5rem" @click="deleteA" class="cursor">
            删除选中商品</span
          >
        </div>
        <div class="bottom-center">
          已选<span>{{ nums }}</span
          >件 &nbsp;&nbsp;应付金额<i>￥</i><span>{{ allprice }}</span>
        </div>
        <div class="bottom-right cursor" @click="Buys">提交购买申请</div>
      </div>
      <div class="pagination">
        <div>
          <!-- <el-button @click="tostart">首页</el-button> -->
        </div>

        <el-pagination
          @current-change="handleCurrentChange"
          background
          :current-page.sync="page_now"
          :page-size="currentPage"
          layout="prev, pager, next,jumper"
          :total="page_total"
        ></el-pagination>
        <div class="pages">
          <!-- <el-button @click="toend">尾页</el-button> -->
          <!-- <div>共{{ page_total }}页</div> -->
        </div>
      </div>
    </div>
    <div style="width: 100%; height: 0.8rem"></div>
    <botbox style="z-index: 9999"></botbox>
  </div>
</template>

<script>
import headerbox from "../components/boxtop";
import botbox from "../components/botts";
import "../../public/statics/css/base.css";
import { auth, anth } from "../request/api";
export default {
  name: "shoucang",
  data() {
    return {
      loading: true,
      num: "",
      comeType: 1,
      currentPage: 1,
      page_now: 1,
      page_total: 1,
      checkList: [],
      cartotal: 0,
      cangtotal: 0,
      checkall: false,
      checkall1: false,
      allprice: 0,
      nums: 0,
      dataList: [],
      dataList1: [],
    };
  },
  components: {
    headerbox,
    botbox,
  },
  created() {
    this.comeType = this.$route.query.types;
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 200);
    if (this.comeType == 2) {
      this.getCar(this.page_now);
      this.getCang(this.page_now);
    } else {
      this.getCang(this.page_now);
      this.getCar(this.page_now);
    }
  },

  methods: {
    getCar(page) {
      if (page != "undefined") {
        this.page_now = page;
      } else {
        this.page_now = 1;
      }
      let url = "/v1/shop/my/cart";
      let data = {
        page: this.page_now,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          console.log(res);
          res.data.data.list.forEach((e) => {
            e.checked = false;
          });
          this.dataList = res.data.data.list;
          this.cartotal = res.data.data.total;
          this.page_now = Number(res.data.data.current_page);
          this.page_total = Number(res.data.data.pageall);
        }else{
          this.$message({
            type:'error',
            message:res.data.msg
          })
        }
      });
    },
    handleCurrentChange(e) {
      this.page_now = e;
      if (this.comeType == 1) {
        this.getCar(e);
      } else {
        this.getCang(e);
      }

      // this.searchShop(e);
    },
    getCang(page) {
      if (page != "undefined") {
        this.page_now = page;
      } else {
        this.page_now = 1;
      }
      let url = "/v1/shop/my/collect";
      let data = {
        page: this.page_now,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          console.log(res);
          this.dataList1 = res.data.data.list;
          this.page_now = Number(res.data.data.current_page);
          this.page_total = Number(res.data.data.pageall);
          this.cangtotal = res.data.data.total;
        }else{
          this.$message({
            type:'error',
            message:res.data.msg
          })
        }
      });
    },
    Buys() {
      let arr = [];
      let arr1 = {};
      this.dataList.forEach((e) => {
        if (e.checked == true) {
          arr.push(e.id);
        }
      });
      if(arr.length>0){
              arr1 = arr.join(",");
      let url = "/v1/shop/my/pay";
      let data = {
        id: arr1,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            type: "success",
            message: "购买申请提交成功",
          });
          this.getCar(1);
          setTimeout(() => {
             this.cout();
          }, 200);
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
      }else{
          this.$message({
            type: "请选择要购买的商品",
            message: res.data.msg,
          });
      }

    },
    changeType(e) {
      this.comeType = e;
      this.nums = 0;
      this.page_now = 1;
      this.allprice = 0;
      this.checkall = false;
      if (e == 1) {
        this.getCar(this.page_now);
      } else if (e == 2) {
        this.getCang(this.page_now);
      }
    },
    deleteC(e, unique) {
      let url = "/v1/shop/my/delCart";
      let data = {
        id: e,
        product_attr_unique: unique,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.getCar(this.page_now);
          setTimeout(() => {
            console.log(123);
            this.cout();
          }, 200);
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    addCang(e) {
      let url = "/v1/shop/my/addCollect";
      let data = {
        id: e,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            type: "success",
            message: "收藏成功",
          });
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    todetail(id) {
      console.log(123);
      this.$router.push({
        path: "/detail",
        query: {
          id: id,
        },
      });
    },
    addCar(e) {
      let url = "/v1/shop/my/addCart";
      let data = {
        id: e,
        num: 1,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            type: "success",
            message: "添加成功",
          });
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    qCang(e) {
      let url = "/v1/shop/my/delCollect";
      let data = {
        id: e,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            type: "success",
            message: "取消成功",
          });
          this.getCang(1);
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    deleteA() {
      let arr = [];
      let arr1 = {};
      // // let arr1=[];
      this.dataList.forEach((e, index) => {
        if (e.checked == true) {
          arr.push(e.id);
          //  this.deleteOne(e.id)
        }
      });

       if (arr.length > 0) {
        arr1 = arr.join(",");
        this.deleteOne(arr1);
      } else {
       this.$message({
            type: "error",
            message: "请选择要删除的商品",
          });
      }
      // this.dataList = arr;
    },
    deleteOne(e) {
      let url = "/v1/shop/my/delCart";
      let data = {
        id: e,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            type: "success",
            message: "删除成功",
          });

          this.getCar(this.page_now);
          setTimeout(() => {
            console.log(123);
            this.cout();
          }, 200);
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    handleChange(e, i) {
      this.allprice = 0;
      this.nums = 0;
      this.cout();
      this.dataList.forEach((e) => {
        e.subtotal = (e.price * e.cart_num).toFixed(2);
      });
      let url = "/v1/shop/my/cart_num";
      let data = {
        id: e,
        num: i,
      };
      auth(url, data).then((res) => {
        if (res.data.code == 1) {
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    tableRowClassName({ row, rowIndex }) {
      //把每一行的索引放进row
      row.index = rowIndex;
    },
    onRowClick(row, event, column) {
      console.log(row.index);
    },
    cout() {
      let arr = [];
      this.allprice = 0;
      this.nums = 0;
      // let price = 0;
      this.dataList.forEach((e) => {
        if (e.checked == true) {
          arr.push(e);
          console.log(e);
          let price = Number(e.price) * Number(e.cart_num);
          console.log(price);
          this.allprice += price;
          let nums = Number(e.cart_num);
          this.nums += nums;
          console.log(this.allprice);
          return this.price;
          return this.nums;
        }
      });
      // this.nums=arr.length
      if (arr.length == this.dataList.length) {
        this.checkall = true;
      } else {
        this.checkall = false;
      }
    },
    handleCheckAllChange(val) {
      // this.cout();
      console.log(123);
      if (this.checkall == true) {
        this.dataList.forEach((e) => {
          e.checked = true;
        });
        this.cout();
      }

      if (this.checkall == false) {
        this.dataList.forEach((e) => {
          e.checked = false;
        });
        this.cout();
      }
    },
    jumppre() {
      this.$router.push("/shop");
    },
  },
};
</script>

<style scoped lang='scss'>
.shoucangbox {
  .cursor {
    cursor: pointer;
  }
  .headerbox {
    z-index: 999;
  }
  .fixedcolor {
    width: 100%;
    height: 0.6rem;
    background: #2c3e50;
    position: fixed;
    top: 0;
    z-index: 998;
  }
  .pagination {
    margin-top: 0.3rem;
    margin-bottom: 1rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    font-size: 0.2rem;
    font-family: PingFang SC !important;
    font-weight: bold;
    color: #333333;
    opacity: 1;
    /deep/ .el-button {
      font-size: 0.2rem;
      font-family: PingFang SC !important;
      font-weight: bold;
      color: #333333;
    }
    /deep/ .el-pagination__jump {
      font-size: 0.2rem;
      font-family: PingFang SC !important;
      font-weight: bold;
      color: #333333;
    }
    /deep/ .number {
      font-size: 0.2rem;
      font-family: PingFang SC !important;
      font-weight: bold;
      color: #333333;
      background-color: #fff;
      width: 0.5rem;
      height: 0.5rem;
      line-height: 0.5rem;
      border: 1px solid #d8d8d8;
    }
    /deep/ .el-icon-more {
      font-size: 0.2rem;
      font-family: PingFang SC !important;
      font-weight: bold;
      color: #333333;
      background-color: #fff;
      width: 0.5rem;
      height: 0.5rem;
      line-height: 0.5rem;
      border: 1px solid #d8d8d8;
    }
    /deep/ .el-pagination__editor {
      font-size: 0.2rem;
      font-family: PingFang SC !important;
      font-weight: bold;
      color: #333333;
      background-color: #fff;
      width: 0.7rem;
      height: 0.5rem;
      line-height: 0.5rem;
      // border: 1px solid #d8d8d8;
    }
    /deep/ .el-input__inner {
      font-size: 0.2rem;
      font-family: PingFang SC !important;
      font-weight: bold;
      color: #333333;
      background-color: #fff;
      width: 0.5rem;
      height: 0.3rem;
      line-height: 0.3rem;
      margin: 0 0.1rem;
      border: 1px solid #d8d8d8;
    }
    /deep/ li {
      font-size: 0.2rem;
      font-family: PingFang SC !important;
      font-weight: bold;
      color: #333333;
      background-color: #fff;
      width: 0.5rem;
      height: 0.5rem;
      line-height: 0.5rem;
      border: 1px solid #d8d8d8;
    }
    /deep/ .btn-prev {
      font-size: 0.2rem;
      font-family: PingFang SC !important;
      font-weight: bold;
      color: #333333;
      background-color: #fff;
      width: 0.5rem;
      height: 0.5rem;
      line-height: 0.5rem;
      border: 1px solid #d8d8d8;
    }
    /deep/ .btn-prev:disabled {
      color: #ccc;
    }
    /deep/ .btn-next:disabled {
      color: #ccc;
    }
    /deep/ .btn-next {
      font-size: 0.2rem;
      font-family: PingFang SC !important;
      font-weight: bold;
      color: #333333;
      background-color: #fff;
      width: 0.5rem;
      height: 0.5rem;
      line-height: 0.5rem;
      border: 1px solid #d8d8d8;
    }
    /deep/ .btn-quickprev {
      font-size: 0.2rem;
      font-family: PingFang SC !important;
      font-weight: bold;
      width: 0.5rem;
      height: 0.5rem;
      line-height: 0.5rem;
      border: 1px solid #d8d8d8;
    }
    /deep/ .btn-quickprev:before {
      content: "<<";
      // color: #333333;
    }
    /deep/ .btn-quicknext:before {
      content: ">>";
      // color: #333333;
    }
    /deep/ .el-icon-more:before {
      content: "...";
    }

    .pages {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
  // /deep/ .el-checkbox__inner {
  //   border-radius: 50%;
  // }
  // 	/*表格表头全选*/
  // .el-table /deep/.DisabledSelection .cell .el-checkbox__inner{
  //   margin-left: -30px;
  //   position:relative;
  // }
  // .el-table /deep/.DisabledSelection .cell:before{
  //   content:"全选";
  //   position:absolute;
  //   right:11px;
  // }
   /deep/ .el-input-number {
    height: 0.5rem;
    line-height: 0.5rem;
    box-sizing: content-box;
  }
  /deep/ .el-input-number {
    width: 2rem;
    line-height: 0.5rem;
  }

  /deep/ .el-input-number__decrease {
    height: calc(0.5rem - 2px);
    line-height: calc(0.5rem - 2px);
    box-sizing: content-box;
    border-radius: 2px;
  }
  /deep/ .el-input-number__increase {
    height: calc(0.5rem - 2px);
    line-height: calc(0.5rem - 2px);
    box-sizing: content-box;
    border-radius: 2px;
  }
  /deep/ .el-input__inner {
    height: 0.5rem;
    line-height: 0.5rem;
    // border: none;
    border-radius: 0;
  }
  .shoucang-top {
    margin-top: 0.6rem;
    padding: 0.2rem 12%;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);
    .left {
      width: 20%;

      img {
        width: 100%;
        // height: 70px;
      }
    }
  }
  .shoucang-content {
    padding: 0 12%;
    /deep/ th {
      .el-checkbox {
        display: none;
      }
    }
    .dec-top {
      display: flex;
      justify-content: start;
      align-items: center;

      font-size: 0.3rem;
      font-family: PingFang SC;
      font-weight: bold;

      color: rgba(51, 51, 51, 1);
      padding-top: 0.1rem;
      .active1 {
        color: #999;
        border-top: 1px solid #e1dddd;
        padding-top: calc(0.1rem - 1px);
      }
      .active {
        color: #397ea9;
        border-top: 0.1rem solid #397ea9;
      }
      div {
        //  width: 238px;
        padding: 0 0.2rem;
        width: 2.5rem;
        height: 1rem;
        line-height: 1rem;
        border: 1px solid #e1dddd;
        opacity: 1;
        border-radius: 0px;
        box-sizing: border-box;
      }
    }
    .dec-content {
      .el-table {
        margin: 0 !important;
      }
      /deep/ th {
        background-color: rgba(225, 221, 221, 1) !important;
        /deep/ .el-checkbox {
          display: none;
        }
      }
      .d1 {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        font-size: 0.2rem;
        height: 1.4rem;
        span {
          padding: 0.1rem 0;
          box-sizing: border-box;
          display: block;
          height: 100%;
        }
      }
      .d2 {
        width: 1.4rem;
        height: 1.4rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .d3 {
        width: 4rem;
        // padding: 0.1rem 0;
        font-family: PingFang SC;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        box-sizing: border-box;
        margin-left: 0.2rem;
        display: flex;
        align-items: flex-start;
        height: 100%;
        flex-wrap: wrap;
        span {
          width: 100%;
          height: 50%;
          display: block;
          text-align: left;
          white-space: pre-wrap;
        }
      }
      .d4 {
        display: flex;
        align-self: center;
        flex-wrap: wrap;
        justify-content: center;
        height: 1.4rem;
        span {
          width: 100%;
          display: block;
          text-align: center;
          padding: 0.1rem;
          font-size: 0.2rem;
          // text-align: left;
          white-space: pre-wrap;
          font-family: PingFang SC;
          font-weight: bold;
        }
      }
      .d9 {
        display: flex;
        align-self: center;
        flex-wrap: wrap;
        justify-content: center;
        height: 1.4rem;
        span {
          width: 60% !important;
          display: block;
          font-size: 0.2rem;
          text-align: center;
          width: 1.4rem;
          font-family: PingFang SC;
          font-weight: 300;
          white-space: pre-wrap;
        }
      }
      .d7 {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        height: 1.4rem;
        justify-content: center;
        span {
          width: 100%;
          display: block;
          padding: 0.1rem 0;
          box-sizing: border-box;
          font-size: 0.2rem;
          text-align: left;
          white-space: pre-wrap;
        }
      }
      .d5 {
        font-size: 0.25rem;
        color: #ff9a26;
        font-family: PingFang SC;
        font-weight: bold;
      }
      .d6 {
        color: rgba(245, 61, 61, 1);
        font-family: PingFang SC;
      }
      .d8 {
        padding: 0.1rem 0.2rem;
        height: 0.4rem;
        line-height: 0.2rem;
        background: #ff9a26;
        opacity: 1;
        border-radius: 2px;
        font-size: 0.15rem !important;
        font-family: PingFang SC;

        width: 1.4rem;
        text-align: center;
        color: #ffffff;
        opacity: 1;
        box-sizing: border-box;
      }
      .d10 {
        font-size: 0.1rem;
        font-family: PingFang SC;

        color: #333333;
        opacity: 1;
      }
    }
    .content-bottom {
      height: 0.8rem;
      display: flex;
      align-items: center;
      background: rgba(153, 153, 153, 0.1);
      border: 1px solid rgba(0, 0, 0, 0.1);
      // opacity: 0.1;
      border-radius: 0px;

      font-size: 0.25rem;
      font-family: PingFang SC;
      font-weight: 600;

      color: rgba(51, 51, 51, 1);
      opacity: 1;
      .bottom-left {
        width: 40%;
        text-align: left;
        padding-left: 0.3rem;
        box-sizing: border-box;
      }
      .bottom-center {
        width: 48%;
        font-family: PingFang SC;
        font-weight: 400;

        i {
          padding: 0 0.05rem;
          color: rgba(255, 154, 38, 1);
          font-style: normal;
          font-weight: bold;
        }
        span {
          padding: 0 0.05rem;
          color: rgba(255, 154, 38, 1);
          font-size: 0.4rem;
          font-weight: bold;

          box-sizing: border-box;
        }
      }
      .bottom-right {
        width: 12%;

        // padding: 0.3rem;
        height: 0.8rem;
        line-height: 0.8rem;
        background: #ff9a26;
        opacity: 1;
        border-radius: 0px;
        box-sizing: border-box;
        color: #fff;
        font-family: PingFang SC;
        font-weight: bold;
      }
    }
  }
 

  // /deep/ .el-input-number__decrease {
  //   height: 0.5rem;
  //   line-height: 0.5rem;
  //   box-sizing: content-box;
  // }
  // /deep/ .el-input-number__increase {
  //   height: 0.5rem;
  //   line-height: 0.5rem;
  //   box-sizing: content-box;
  // }
  // /deep/ .el-input__inner {
  //   height: 0.5rem;
  //   line-height: 0.5rem;
  //   border: none;
  //   border-radius: 0;
  // }
  /deep/ .el-input {
    position: static;
  }
  // /deep/ .el-input__inner {
  //   height: 0.45rem;
  //   line-height: 0.45rem;
  //   border: none;
  //   border-radius: 0;
  // }
  /deep/ .el-input {
    position: static;
  }
}
</style>

